import { NgModule } from '@angular/core';
import { FilesService } from "./services/files.service";
import { DesignFactoryModule } from "./designFactory/designFactory.module";
import { NgSharedModule } from "./ng/ng-shared.module";
import { AngularSharedModule } from "./angularShared/angularShared.module";
import { PipesModule } from "./pipes/pipes.module";
import { OpenModalService } from "../core/services/openModal.service";

@NgModule({
  imports: [
    DesignFactoryModule,
    NgSharedModule,
    AngularSharedModule
  ],
  exports: [
    DesignFactoryModule,
    NgSharedModule,
    AngularSharedModule,
    PipesModule
  ],
  providers: [FilesService, OpenModalService]
})
export class SharedModule {
}
